import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GriddataService } from '../services/griddata.service';
import { Subscription, forkJoin } from 'rxjs';
import { GridRefreshComponent } from '../core/grid/grid-refresh/grid-refresh.component';
import { OSPStateService } from '../services/osp-state.service';
import { LookupService } from '../services/lookup/lookup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { logErrors } from '../shared/logger';
import { HeaderCheckboxComponent } from '../core/grid/header-checkbox/header-checkbox.component';
import { RowCheckboxComponent } from '../core/grid/row-checkbox/row-checkbox.component';
import { dateComparator, dateFilterComparator, resetSortingAndFilters } from '../constants';
import { StockingPaceServiceService } from '../services/stocking-pace-service.service';
import { ExcelService } from '../services/excel.service';
import { validateVanningDates, warningMessage } from '../constants';
import { DevanningService } from '../services/devanning/devanning.service';
import * as mm from 'moment-timezone';
import { isFakeTouchstartFromScreenReader } from '@angular/cdk/a11y';
import { ActivatedRoute, Router } from '@angular/router';
import { DataServiceService } from '../services/air-freight-validation/data-service.service';
import { ProdprogressService } from '../services/production-progress/production-progress.service';
import { DefaultService } from '../services/default.service';
@Component({
  selector: 'app-devan-history',
  templateUrl: './devan-history.component.html',
  styleUrls: ['./devan-history.component.scss'],
})
export class DevanHistoryComponent implements OnInit,OnDestroy {
  headerCheckboxChecked: any;
  dateComparator: any;
  @ViewChild('osPartsGrid') osPartsGrid;
  isEditMode = false;
  editEnabled: boolean = false;
  defaultPageSize: any = 100000;
  offset: number = 0;
  user: any;

  userRole: any;
  dataCount: number = 0;
  DevanSubscription$: Subscription;
  FilerSubscription$: Subscription;
  selectedDock: any;
  selectedModuleType: any = [];
  selectedVanMonth: any = [];
  order_lot: any;
  disablePartNumber: boolean;
  disableKanban: boolean;

  columnDefs: any;
  rowData: any;
  rowSelection: any;
  gridOptions: any;
  pagination: any;
  paginationPageSize: any;
  context: any;
  suppressClickEdit: boolean;
  frameworkComponents: any;
  tooltipShowDelay: any;
  editType: any;
  search_form = {
    dock: '',
    module_type: '',
    van_month: '',
  };
  dockModuleList: any = [];

  vanMonthList: any = [];
  moduleTypeList: any = [];

  dockList: any = [];
  llpDockList: any = [];
  partNoList: any = [];
  partNoListAll: any = [];
  kanbanList: any = [];
  containerList: any = [];
  partNo: any;
  kanbanNo: any;
  containerFrom: any;
  containerTo: any;
  stockingDateFrom: any;
  stockingDateTo: any;
  totalStockedQty: any;
  avgStockedQtyPerDay: any;
  res_part_description: any;
  res_kanbanNo: any;
  res_partNo: any;
  partSelect: any;
  kanbanselect: any;
  selectedKanban: any;
  selectedPartNo: any;
  partnorowdata: any;

  selectedAction = '';

  queryLimit = 1200;
  partDescription: any;
  actionOptions = [{ action_name: 'Container Tap' }, { action_name: 'Procurement' }];


  // variables used for navigation from procurement
  orderDetailsForEdit: any = null;
  for_edit = false;
  for_add_part = false;
  partdata = null;

  disablemodule = true;
  devanFilter:any;
  constructor(
    private readonly gridDataService: GriddataService,
    private readonly stateService: OSPStateService,
    private readonly lookupService: LookupService,
    private readonly spinner: NgxSpinnerService,
    private readonly stockingService: StockingPaceServiceService,
    private readonly excelService: ExcelService,
    private readonly devanningService: DevanningService,
    private router: Router,
    private dataService: DataServiceService,
    private readonly prodProgressService: ProdprogressService,
    private readonly defaultService : DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }
  ngOnInit(): void {

    let showData = localStorage.getItem('FromDevan')
    if (showData === 'true') {
      this.dataService.filteredData$.subscribe((data: any) => {
        if (data) {
          console.log(data, 'data..........');
          this.orderDetailsForEdit = data;

        }
      });
    } else {
      this.orderDetailsForEdit = []
    }
    localStorage.setItem('FromDevan', 'false')

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state;

    this.columnDefs = [
      {
        headerName: '',
        suppressSorting: true,
        field: 'rowCheckBox',
        sortable: false,
        width: 44,
        suppressMenu: true,
        floatingFilterComponentFramework: GridRefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
      },
      {
        headerName: 'Stocking Date',
        field: 'stocking_date',
        minWidth: 140,
        maxWidth: 180,
        flex: 1,
        floatingFilter: true,
        sortable: true,
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
          comparator: dateFilterComparator,
        },
      },
      {
        headerName: 'Stocked',
        field: 'stocked',
        minWidth: 80,
        maxWidth: 120,
        flex: 1,
        floatingFilter: true,
        tooltipField: 'name',
        sortable: true,
      },
      {
        headerName: 'Container',
        field: 'container_renban',
        minWidth: 120,
        maxWidth: 200,
        flex: 2,
        floatingFilter: true,
        sortable: true,
      },
      {
        headerName: 'Renban Qty (pcs)',
        field: 'containerQuantity',
        minWidth: 100,
        maxWidth: 140,
        flex: 1,
        floatingFilter: true,
        sortable: true,
      },
      {
        headerName: 'Module',
        field: 'module_number',
        minWidth: 100,
        maxWidth: 120,
        flex: 1,
        floatingFilter: true,
        sortable: true,
      },
      {
        headerName: 'Module Qty (pcs)',
        field: 'mod_qty_received',
        minWidth: 100,
        maxWidth: 140,
        flex: 1,
        floatingFilter: true,
        sortable: true,
      },
      {
        headerName: 'Daily Qty (pcs)',
        field: 'dailyQuantity',
        minWidth: 100,
        maxWidth: 140,
        flex: 1,
        floatingFilter: true,
        filter: 'agNumberColumnFilter',
        sortable: true,
      },
    ];

    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
    };

    this.DevanSubscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
    });

    // this.lookupService.getqpcforpart().subscribe({
    //   next: (res) => {
    //     if (Array.isArray(res?.body?.data)) {
    //       const qpcPart = res.body.data;
    //       // .map((item: any) => {

    //       //   return { item_id: item?.item_id ?? null };
    //       // });
    //       this.partNoListAll.push(...qpcPart);
    //       console.log(' this.qpcPart', this.partNoListAll);
    //     }
    //     this.spinner.hide();
    //   },
    //   complete: () => {
    //     if (this.orderDetailsForEdit?.length != 0) {
    //       this.appendprocurementDetails();
    //     }
    //   },
    //   error: (error) => this.errorCallback(error),
    // });
  }

  getqpcforpart(){
    this.lookupService.getqpcforpart().subscribe({
      next: (res) => {
        if (Array.isArray(res?.body?.data)) {
          const qpcPart = res.body.data;
          // .map((item: any) => {

          //   return { item_id: item?.item_id ?? null };
          // });
          this.partNoListAll.push(...qpcPart);
          console.log(' this.qpcPart', this.partNoListAll);
        }
        if(this.assignDefaultDock()){
          this.dockChange();
        }
        this.spinner.hide();
      },
      complete: () => {
        if (this.orderDetailsForEdit?.length != 0) {
          this.appendprocurementDetails();
        }
      },
      error: (error) => this.errorCallback(error),
    });
  }
  getLLPDocks() {
    this.spinner.show();
    // const input = {
    //   businessEntity:localStorage.getItem('namcvalue'),

    // }
  

    const input = {
      business_entity: localStorage.getItem('namcvalue'),
      workid: this.user,
      user_role: this.userRole,
    };

    //const lookupSubscriptions = [this.prodProgressService.getDock(data)];
    this.prodProgressService.getDock(input).subscribe({
      next: (res) => {
        this.spinner.show();
        if (Array.isArray(res?.body)) {
          const llpDocks = res.body.map((item: any) => {
           
            return { llpDocks: item?.dock ?? null };
          });
          this.llpDockList.length = 0;     
          this.llpDockList.push(...llpDocks);
      
        }
        this.getqpcforpart();
        this.spinner.hide();
      },
      error: (error) => this.errorCallback(error),

    });
  }
  getContainerList() {
    this.containerList = [];
    const containerInput = {
      businessEntity: localStorage.getItem('namcvalue'),
      dock: this.selectedDock?.llpDocks || '',
    };
    this.devanningService.getContainerList(containerInput).subscribe({
      next: (res) => {
        if (Array.isArray(res?.body?.data)) {
          const containers = res.body.data.map((item: any) => {
            return { container: item?.container_renban ?? null };
          });
    
          this.containerList.push(...containers);
    
          // Sort the list by 'container' field in ascending order
          this.containerList.sort((a, b) => {
            if (a.container == null) return 1;
            if (b.container == null) return -1;
            return a.container.localeCompare(b.container); // For string sorting
          });
    

          this.kanbanNo = this.partNo = null;
          this.partSelect = this.kanbanselect = false;
          const input = {
            businessEntity: localStorage.getItem('namcvalue'),
            dock: this.selectedDock.llpDocks,
          };
        
          if (this.devanFilter?.containerFrom) {
            const cntFromMatch = this.containerList.find(
              (item) => item.container === this.devanFilter.containerFrom
            );
            if (cntFromMatch) {
              this.containerFrom = cntFromMatch;
            }
          }
          this.devanningService.getContainerAndStockingDateTo(input).subscribe({
            error: (error) => this.errorCallback(error,'getContainerAndStockingDateTo'),
            next: (res) => {
              if (res.body && res.body.container_renban) {
                const match = this.containerList.find(
                  (item) => item.container === res.body.container_renban
                );
                if (match) {
                  this.containerTo = match;
                }
      
                this.spinner.hide();
              }
              if (res.body && res.body.max_stocking_date) {
                this.stockingDateTo = res.body.max_stocking_date;
                const date = new Date(res.body.max_stocking_date);
                this.stockingDateTo = date.toISOString().split('T')[0];
      
                this.spinner.hide();
              } else {
                this.rowData = [];
                this.spinner.hide();
              }
            },
          });
          console.log('this.containerList', this.containerList);
        }
      },
      error: (error) => this.errorCallback(error),
    });
    
  }
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('userName');

  warningMessage: string;
  successMessage: string;

  removeMessage() {
    this.successMessage = '';
    this.warningMessage = '';
  }
  onActionSelect(action: any) {
    this.selectedAction = action;
    localStorage.setItem('FromDevan', 'true')

    // Check which action was selected and handle accordingly
    switch (action.action_name) {
      case 'Container Tap':
        this.moveToContainerTap();
        break;
      case 'Procurement':
        this.moveToDevanHistory();
        break;
      default:
        break;
    }
  }

  moveToContainerTap() {
    this.dataService.sendFilteredData({
      forEdit: false,
      data: null,
      dock: this.selectedDock?.llpDocks,
      kanban: this.selectedKanban?.kanban

    });
    this.router.navigate(['inventory/containertap']);
  }
  moveToDevanHistory() {
    console.log("this.selecteddock", this.containerTo?.container)
    this.dataService.sendFilteredData({
      forEdit: false,
      data: null,
      part: this.selectedPartNo?.item_id,
      dock: this.selectedDock?.llpDocks,
      kanban: this.selectedKanban?.kanban,
      containerFrom: this.containerFrom?.container || '',
      containerTo: this.containerTo?.container || '',
      stockingDateFrom: this.stockingDateFrom,
      stockingDateTo: this.stockingDateTo,
    });

    this.devanningService.setFilters({containerFrom: this.containerFrom?.container || '',
      containerTo: this.containerTo?.container || '',
      stockingDateFrom: this.stockingDateFrom,
      stockingDateTo: this.stockingDateTo,});

    this.router.navigate(['inventory/Procurement']);
  }
  async onKanbanChange() {
    //this.selectedKanban = {kanban: this.orderDetailsForEdit.kanban}
    this.partSelect = true;
    this.kanbanselect = false;
    this.disablePartNumber = true;
    this.selectedPartNo = this.selectedKanban;
    this.partnorowdata = [];
    this.partnorowdata.push(this.selectedPartNo);
  }

  userCheckChanged(checked, rowIndex) {
    this.spinner.show();
    const rowNode = this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }
  toggleHeaderCheckbox(checked) {
    if (!checked) {
      this.headerCheckboxChecked = false;

      this.osPartsGrid.gridOptions.api.refreshHeader();

      return;
    }

    const rowCount = this.osPartsGrid.gridOptions.rowData.length;
    const selectedRowCount = this.osPartsGrid.gridOptions.rowData.filter((x) => x.rowCheckBox === true).length;

    if (rowCount === selectedRowCount) {
      this.headerCheckboxChecked = true;

      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
  }
  headerCheckChanged(event) {
    this.headerCheckboxChecked = event.checked;
    const headerChecked = event.checked;
    const isEditable = this.isEditMode;
    this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
      if (headerChecked) {
        if (isEditable) {
          rowNode.data.checkedEditMode = true;
        }
        rowNode.data.rowCheckBox = true;
      } else {
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
      }
      rowNode.setData(rowNode.data);
    });
  }

  onResetDropDown() {
    this.selectedAction = ''

    this.removeMessage();
    // this.appendDockModuleData(this.dockModuleList);
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }
    //
    this.partNo = '';
    this.kanbanNo = '';
    this.containerFrom = '';
    this.containerTo = '';
    this.stockingDateFrom = '';
    this.stockingDateTo = '';
    this.selectedDock = '';
    this.partSelect = this.kanbanselect = false;
    this.kanbanList = this.partNoList = this.partnorowdata = [];
    this.selectedKanban = this.selectedPartNo = this.selectedDock = null;
    this.setPageSizeToAll(this.defaultPageSize);
    this.rowData = [];
    this.offset = 0;
    this.disableKanban = false;
    this.disablePartNumber = false;
  }

  onSearch(offset) {
    this.selectedAction = ''


    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();

      this.resetGrid();
    }

    this.removeMessage();

    if (offset === 0) {
      this.setPageSizeToAll(this.defaultPageSize);
      this.rowData = [];
      this.osPartsGrid.gridOptions.api.setRowData(this.rowData);

      this.offset = 0;
      this.spinner.show();
    }

    if (!this.selectedDock || (!this.selectedPartNo && !this.selectedKanban)) {
      this.rowData = [];
      window.scroll(0, 0);
      this.warningMessage = 'Dock is required, and either Part No or Kanban No must be provided';
      this.spinner.hide();
      return false;
    }
    if (this.stockingDateFrom && this.stockingDateTo) {
      const fromDate = new Date(this.stockingDateFrom);
      const toDate = new Date(this.stockingDateTo);

      if (fromDate > toDate) {
        this.rowData = [];
        window.scroll(0, 0);
        this.warningMessage = 'Stocking From date must be earlier than or equal to Stocking To date';
        this.spinner.hide();
        return false;
      }
    }
    // let selectedDock;
    const data = {
      offset: offset,
      limit: this.queryLimit,
      business_entity: this.namcValue,
      dockValue: this.selectedDock.llpDocks,
      part_number: this.selectedPartNo.item_id,
      kanban: this.selectedKanban.kanban,
    //  containerFrom: this.containerFrom?.container || '',
    containerFrom: this.containerFrom?.container
    ? this.containerFrom.container
    : this.devanFilter?.containerFrom ?? '',
    containerTo: this.containerTo?.container
    ? this.containerTo.container
    : this.devanFilter?.containerTo ?? '',
     // containerTo: this.containerTo?.container || '',
      stockingDateFrom: this.stockingDateFrom,
      stockingDateTo: this.stockingDateTo,
    };
      
    this.devanningService.getDevanningHistory(data).subscribe({
      error: (error) => this.errorCallback(error,'getDevanningHistory'),
      next: (res) => {
        console.log('gridres', res);
        if (res.body && res.body.devanHistory.data) {
          const result = res.body.devanHistory.data;
          result.devanningHistoryModules.forEach((row) => {
            if (row.stocking_date) {
              const [year, month, day] = row.stocking_date.split('T')[0].split('-');
              row.stocking_date = `${month}/${day}/${year}`;
            }
          });
          this.rowData.push(...result.devanningHistoryModules);
          const SelectedParts = this.partNoListAll.find((part) => part.item_id === this.selectedPartNo.item_id);
          this.res_part_description = SelectedParts.part_description;
          this.res_kanbanNo = SelectedParts.kanban;
          this.res_partNo = SelectedParts.item_id;
          // this.rowData.forEach((row) => {
          //   if (row.stocking_date) {
          //     const [year, month, day] = row.stocking_date.split('T')[0].split('-');
          //     row.stocking_date = `${month}/${day}/${year}`;
          //   }
          // });
          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          this.totalStockedQty = result.totalStockedQty;
          this.avgStockedQtyPerDay = result.averageStockedQty;
          this.order_lot = result.orderLot;
          console.log('test', res);
          this.dataCount = parseInt(result.rowCount) || 0;
          const records = this.dataCount - (this.offset + 1) * this.queryLimit;
          if (records >= 1) {
            this.offset++;
            this.onSearch(this.offset * this.queryLimit);
          } else {
            this.spinner.hide();
          }
        } else if (res.body && res.body.devanHistory.data == false) {
          this.warningMessage = 'Invalid partNo/kanbanNo combination or partNo/kanbanNo not found!';
          this.rowData = [];
          this.spinner.hide();
        } else {
          this.rowData = [];
          this.spinner.hide();
        }

        this.setPageSizeToAll();
      },
    });
    return true;
  }
  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);

      return;
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;

    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }

    this.onPageSizeChanged();
  }

  checkIfAnySelected() {
    if (this.selectedModuleType.length > 0 && this.selectedDock.length > 0 && this.selectedVanMonth.length > 0) {
      return true;
    }
    return false;
  }
  initializeData() {
    //



    // this.resetVariablesState();
    this.spinner.show();
    this.rowData = [];

    this.namcValue = localStorage.getItem('namcvalue');

    this.user = localStorage.getItem('workdayId');
    this.userRole = localStorage.getItem('UserRoles');


    this.onResetDropDown();

    //end
    console.log('initialize data called');
    this.rowData = [];
    // this.spinner.show();

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }

    this.onResetDropDown();
    this.getLLPDocks();
    const lookupSubscriptions = [this.lookupService.getDock(), this.lookupService.getUserShowHideColumns()];
  }

  errorCallback = (error,apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if(error?.error?.message){
      backendMessage = error.error.message;
    } else if(error?.message){
      backendMessage = error.message;
    }
    if(backendMessage){
      detailedMessage += `| ${backendMessage}`;
    } else if(apiName){
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };
  dockChange(): void {
    this.spinner.show();
    this.disableKanban = false;
    this.disablePartNumber = false;
    this.getContainerList();

    this.partNoList = this.partNoListAll.filter((x) => {
      return x.dock === this.selectedDock.llpDocks;
    });
    this.kanbanList = this.partNoList

    // Sort the 'kanban' array inside each item of kanbanList
    const kanbanSet = new Set();
    this.kanbanList = this.kanbanList
      .filter(x => {
        if (!kanbanSet.has(x.kanban)) {
          kanbanSet.add(x.kanban);
          return true;
        }
        return false;
      })
      .sort((a, b) => Number(a.kanban) - Number(b.kanban));

      this.defaultService.setDockCode(JSON.stringify([{dock : this.selectedDock.llpDocks}]));
  }

  assignDefaultDock(){
    try {
      if (this.llpDockList?.length > 0){
        const defaultdockArray : any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.llpDockList.find(item => validDocks.has(item.llpDocks));
          if (this.selectedDock){
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock',error);
      return false;
    }
  }

  onPartNoChange() {
    this.removeMessage();
    this.partSelect = false;
    this.disableKanban = true;
    this.kanbanselect = true;
    this.selectedKanban = this.selectedPartNo;
    this.partnorowdata = [];
    this.partnorowdata.push(this.selectedPartNo);
  }

  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(Number(this.paginationPageSize));
    }
  }

  exportAsXLSX(): void {
    this.removeMessage();

    this.spinner.show();

    // eastern time api
    const easternCurrentDate = String(mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss'));
    console.log(easternCurrentDate);
    let data = [];

    // if (this.headerCheckboxChecked) {

    // }
    this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
      data.push(node.data);
    });

    if (data.length < 1) {
      this.spinner.hide();
      this.warningMessage = warningMessage.noRowsSelected;

      window.scroll(0, 0);
    } else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];

          data.forEach((e) => {
            const obj = {
              stocking_date: e.stocking_date,
              stocked: e.stocked,
              container_renban: e.container_renban,
              containerQuantity: e.containerQuantity,
              module_number: e.module_number,
              mod_qty_received: e.mod_qty_received,
              dailyQuantity: e.dailyQuantity,
            };
            exportData.push(obj);
          });

          const headers = [
            'STOCKING DATE',
            'STOCKED',
            'CONTAINER',
            'RENBAN QTY(PCS)',
            'MODULE',
            'MODULE QTY(PCS)',
            'DAILY QTY (PCS)',
          ];

          const timestamp = easternCurrentDate
            .split('.')[0]
            .replace('T', '_')
            .split('')
            .filter((d) => d !== '-' && d !== ':')
            .join('');

          this.excelService.exportAsExcelFile(exportData, 'DevanningHistory_' + timestamp, headers);
        }
        this.spinner.hide();
      }, 1000);
    }
  }
  consoleLog(element, console_for) {
    console.log(element, 'ms-1 - ' + console_for);
  }

  async appendprocurementDetails() {


     this.devanFilter  = this.devanningService.getFilters();
    
    this.containerFrom= this.devanFilter.containerFrom;
    this.containerTo= this.devanFilter.containerTo ;
  //  this.containerTo = this.containerList.find(
  //   x => x.container === devanFilter.containerTo
  // ) || null;
    this.stockingDateFrom= this.devanFilter.stockingDateFrom;
    console.log('containerList', this.containerList);
    console.log('devanFilter.containerTo', this.devanFilter.containerTo);
    console.log(' this.containerTo',  this.containerTo);
    this.stockingDateTo= this.devanFilter.stockingDateTo;
 
    if (this.orderDetailsForEdit?.dock) {
      this.selectedDock = { llpDocks: this.orderDetailsForEdit.dock };
    } else {
      this.selectedDock = { llpDocks: '' };
    }


    await this.dockChange();



    this.selectedKanban = this.kanbanList?.find((x) => x.kanban === this.orderDetailsForEdit?.kanban) || null;
    await this.onKanbanChange();

    await this.onSearch(0);


  }





  ngOnDestroy(): void {
    this.DevanSubscription$.unsubscribe();

  }

}